import PartnerLogo from './PartnerLogo';

export default PartnerLogo;
